<template>
  <Multiselect
              :class="{'multiselect-sm': small}"
               class=""
               v-model="vModel"
              :disabled="disabled"
               :options="merchants"
               :custom-label="(opt) => `${opt.name} (${opt.email})`"
               track-by="id"
               select-label="Select"
               :placeholder="multiple ? helper.trans('labels.merchants') : helper.trans('labels.merchant')"
               open-direction="bottom"
               :multiple="multiple"
               :searchable="true"
               :loading="isLoading"
               :internal-search="false"
               :clear-on-select="!multiple"
               :close-on-select="!multiple"
               :options-limit="100"
               :limit="1000"
               :show-no-results="false"
               :hide-selected="multiple"
               @search-change="asyncFind"
  >
  </Multiselect>
</template>

<script lang="ts">

import {computed, defineComponent, onMounted, Prop, PropType} from 'vue'
import {debounce, helper} from "@/service/CommonHelper";
import {reactive, toRefs} from "@vue/reactivity";
import {numberFormatter} from "@/service/NumberFormatter";
import Multiselect from "vue-multiselect";
import TraderDTO from "@/models/TraderDTO";
import APIClient from "@/service/APIClient";
import PaginationDTO from "@/models/PaginationDTO";
import MerchantDTO from "@/models/MerchantDTO";

const api = new APIClient()

export default defineComponent({
  emits: ['update:modelValue'],
  components: {
    Multiselect
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    } as Prop<boolean>,
    multiple: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    small: {
      type: Boolean,
      default: true
    } as Prop<boolean>,
    modelValue: {
      type: Object as PropType<any>,
      default: null
    } as Prop<any>,
  },
  setup(props, {emit}) {

    const state = reactive({
      isLoading: false as boolean,
      merchants: [] as MerchantDTO[]
    })

    const asyncFind = debounce(async (query) => {
      state.isLoading = true
      state.merchants = (await api.merchants({limit: 100, offset: 0} as PaginationDTO, {query: query})).items;
      state.isLoading = false
    }, 500);

    const vModel = computed({
      get(): any {
        return props.modelValue
      },
      set(value: any): void {
        emit('update:modelValue', value);
      },
    });

    onMounted(() => {
      asyncFind('')
    });

    return {
      ...toRefs(state),
      vModel,
      asyncFind,
      helper,
      numberFormatter
    }
  }
})
</script>
